angular.module('st')
    .controller('signInController', [
        '$rootScope','$scope','$timeout','$http', '$location',
        function ($rootScope,$scope,$timeout,$http,$location) {
            var ctrl = this;           

            ctrl.Init = function (isPasswordReset, resetCode) {
                $scope.currentScreen = 'signin';
                $scope.processing = false;
                $scope.isPasswordReset = false;
                $scope.feedback = '';
                $scope.signInModel = {};
                $scope.resetPwModel = {};

                var params = $location.search();
                //console.log('params',params);

                if (isPasswordReset == true) {
                    $scope.resetPwModel.ResetCode = resetCode;
                    $scope.isPasswordReset = true;
                    $scope.currentScreen = 'resetpw';
                    $('#sign-in-modal').modal({ backdrop: 'static', keyboard: false, show: true });
                }
            }

            $scope.$watch('currentScreen', function (newValue, oldValue) {
                // set forms to their pristine state on screen change, in case they go back 
                // to them later, like the sign in form after clicking forgot password and then signing in again
                if (oldValue == 'signin' && newValue == 'forgotpw') {
                    ctrl.ResetSignInForm();
                }
                if ((oldValue == 'forgotpw' && newValue == 'pwlinksent') || (oldValue == 'resetpw' && newValue == 'pwchanged')) {
                    ctrl.ResetForgotPwForm();
                }
            });

            ctrl.SignInSubmit = function (form) {
                $scope.signInClicked = true;
                $scope.processing = true;
                $scope.feedback = 'Signing in...'
                grecaptcha.ready(function () {
                    // Named actions (were '' / unnamed). reCAPTCHA scores per action and the
                    // admin console groups score distribution by name, so unnamed tokens pooled
                    // every flow together and made the score useless for tuning. A new name
                    // starts a fresh baseline — allow a warm-up before reading it. Do NOT rename
                    // the existing 'validate_captcha' on the Sitefinity form widgets; that
                    // discards accumulated history for those.
                    grecaptcha.execute($('#captcha-site-key').val(), { action: 'crewards_sign_in' }).then(function (token) {
                        $scope.signInModel.captchaToken = token;
                        $http.post("/rpc/membership/login", $scope.signInModel)
                            .then(function (data) {
                                if (data.data.Success == true) {
                                    $scope.feedback = '';
                                    if ($scope.isPasswordReset == true) {
                                        // if they sign in right after resetting the password, remove the code from the url
                                        window.location.href = ctrl.RemoveQSParam('code', window.location.href)
                                    } else {
                                        window.location.reload();
                                    }
                                } else {
                                    // vista error
                                    var msg = data.data.Message;
                                    $scope.processing = false;
                                    $scope.feedback = msg;
                                }
                            }).catch(function (error) {
                                // our server error
                                $scope.processing = false;
                                $scope.feedback = 'Error occurred while trying to sign in.'
                            })
                    });
                }); 
            }

            ctrl.ForgotPwSubmit = function (form) {
                $scope.fgtPwEmailEntered = true;
                $scope.processing = true;
                $scope.feedback = 'Sending password reset link...';

                grecaptcha.ready(function () {
                    grecaptcha.execute($('#captcha-site-key').val(), { action: 'crewards_forgot_password' }).then(function (token) {
                        $http.post("/rpc/membership/reset-password/initiate", { emailAddress: $scope.fpemail, captchaToken: token } )
                            .then(function (data) {
                                if (data.data.Success == true) {
                                    $scope.currentScreen = 'pwlinksent';
                                    $scope.feedback = '';
                                } else {
                                    // vista error
                                    var msg = data.data.Message;
                                    $scope.processing = false;
                                    $scope.feedback = msg;
                                }
                            }).catch(function (error) {
                                // our server error
                                $scope.processing = false;
                                $scope.feedback = 'Error occurred while trying to send the password reset link.'
                            })
                    });
                }); 
            }

            ctrl.ResetPwSubmit = function (form) {
                $scope.resetPasswordClicked = true;
                $scope.processing = true;
                $scope.feedback = 'Resetting password...';
                grecaptcha.ready(function () {
                    grecaptcha.execute($('#captcha-site-key').val(), { action: 'crewards_reset_password' }).then(function (token) {
                        $scope.resetPwModel.captchaToken = token

                        $http.post("/rpc/membership/reset-password/complete", $scope.resetPwModel)
                            .then(function (data) {
                                if (data.data.Success == true) {
                                    $scope.processing = false;
                                    $scope.currentScreen = 'pwchanged';
                                    $scope.feedback = '';
                                    window.location.href = "/";
                                } else {
                                    // vista error
                                    var msg = data.data.Message;
                                    $scope.processing = false;
                                    $scope.feedback = msg;
                                }
                            }).catch(function (error) {
                                // our server error
                                $scope.processing = false;
                                $scope.feedback = 'Error occurred while trying to reset the password.'
                            })
                    });
                }); 
            }

            ctrl.ResetSignInForm = function () {
                $scope.processing = false;
                $scope.signInClicked = false;
                $scope.feedback = '';
                $scope.signInModel.Username = '';
                $scope.signInModel.Password = '';
                $scope.signinform.$setPristine(true);
                $scope.signinform.$setUntouched(true);
            }

            ctrl.ResetForgotPwForm = function () {
                $scope.processing = false;
                $scope.fgtPwEmailEntered = false;
                $scope.feedback = '';
                $scope.fpemail = '';
                $scope.forgotpwform.$setPristine(true);
                $scope.forgotpwform.$setUntouched(true);
            }

            ctrl.CloseModal = function () {                
                $timeout(function () {
                    ctrl.ResetSignInForm();
                    ctrl.ResetForgotPwForm();
                    $scope.currentScreen = 'signin';
                }, 1000);
            }

            ctrl.IsFieldInvalid = function (field, form) {
                return field.$invalid && (field.$touched || form.$submitted);
            }

            ctrl.IsVistaError = function (form) {
                var signInError = form.$name == 'signinform' && $scope.feedback.toLowerCase().indexOf('username and/or password') > -1;
                var forgotPwError = form.$name == 'forgotpwform' && $scope.feedback.toLowerCase().indexOf('account not found') > -1;
                return signInError || forgotPwError;
            }
            
            ctrl.RemoveQSParam = function (key, sourceURL) {
                var rtn = sourceURL.split("?")[0],
                    param,
                    params_arr = [],
                    queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
                if (queryString !== "") {
                    params_arr = queryString.split("&");
                    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                        param = params_arr[i].split("=")[0];
                        if (param === key) {
                            params_arr.splice(i, 1);
                        }
                    }
                    rtn = rtn + "?" + params_arr.join("&");
                }
                return rtn;
            }
        }
    ]);
